<app-global-header></app-global-header>
<lib-glasspane></lib-glasspane>

<app-loading></app-loading>

<router-outlet></router-outlet>

<footer cdx-footer></footer>
